$(document).ready(function () {

    window.valideKey = function (evt) {
        // El código es la representación decimal ASCII de la tecla presionada.
        var code = (evt.which) ? evt.which : evt.keyCode;

        if (code == 8) { // espacio.
            return true;
        } else if (code >= 48 && code <= 57) { // es un numero
            return true;
        } else { // other keys.
            return false;
        }
    }

    window.loading_small_small = function (div) {
        if ($("#" + div).length > 0) {
            document.getElementById(div).innerHTML = '<center><img src="' + window.location.origin + '/images/loading.gif" border="0" width="90px" /></center>';
        }
    }

    function ajustarAlturaImagen() {
        //en el detalle de item
        if ($('.img-novedad-dinamic').length) {
            $('.img-novedad-dinamic').css('display', 'block');
            $('.img-novedad-dinamic').height($('.img-book-detail').height());
        }

        //en el home de item
        if ($('.img-novedad-home').length) {
            $('.img-novedad-home').css('display', 'block');
            $('.img-novedad-home').height($('.img-books').height());
        }


        //en el buscar item
        if ($('.img-novedad-search').length) {
            $('.img-novedad-search').css('display', 'block');
            $('.img-novedad-search').height($('.img-books').height());
        }


    }

    ajustarAlturaImagen();

    $(window).resize(function () {
        ajustarAlturaImagen();
    });


    window.handleAjaxError = function (jqXHR) {
        // validación de Laravel a campos — lo ignoramos únicamente porque entra en fail xk no pasa la validación
        if (jqXHR.status == 422) {

            let errors = "<ul class=''>";
            let items = "";

            $.each(jqXHR.responseJSON.errors, function (index, value) {
                items = items + "<li class=''>" + value + "</li>";
            });

            errors = errors + items + "</ul>";
            let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                + errors
                + "</div></div></div>";

            document.getElementById('div_message').innerHTML = view;

        } else {
            console.log(jqXHR.status);
            alert("Disculpe, existió un problema");
        }
    }

    //Se agrega este codigo para un submenu iordaz
    $('.dropdown-submenu .dropdown-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $submenu = $(this).next('.dropdown-menu');
        $('.dropdown-submenu .dropdown-menu').not($submenu).hide();
        $submenu.toggle();
    });

    $('.dropdown').on('hidden.bs.dropdown', function() {
        $('.dropdown-submenu .dropdown-menu').hide();
    });




});
